import { Link, useLocation } from "react-router-dom";
import { czyPozycjaAktywna } from "../../lib/nawigacja.js";
import { POZYCJE_ADMINA, type PozycjaMenu } from "./pozycjeMenu.js";

/**
 * L-1, L-2, L-4, L-6: sidebar przezroczysty pod headerem, prawy hairline z wcieciem,
 * pozycje o stalej wysokosci 52px z etykieta do lewej.
 *
 * Ponizej 1024px ten sam element staje sie plywajacym KAFELKIEM (L-11) - przelaczenie
 * robi CSS, nie JS. To swiadome: pary display:none/flex sa komplementarne, a JS jako
 * zrodlo prawdy oznaczalby remount przy resize (gubi fokus) i migotanie na pierwszej klatce.
 *
 * Pozycje przychodza z zewnatrz (pozycjeMenu.ts, wg roli konta). Domyslnie lista administratora, wiec powloka
 * bez jawnej listy wyglada jak dotychczas.
 */

interface Props {
  otwarte: boolean;
  onWybor: () => void;
  refKontenera: React.RefObject<HTMLElement | null>;
  pozycje?: readonly PozycjaMenu[];
}

export function Sidebar({ otwarte, onWybor, refKontenera, pozycje = POZYCJE_ADMINA }: Props): React.JSX.Element {
  const { pathname } = useLocation();
  return (
    <aside className={`app-sidebar${otwarte ? " is-open" : ""}`} id="sidebar" ref={refKontenera}>
      <nav className="app-nav" aria-label="Nawigacja główna">
        {pozycje.map((pozycja) => {
          const { do: doTrasy, etykieta, Ikona } = pozycja;
          const aktywna = czyPozycjaAktywna(pozycja, pathname);
          return (
            <Link
              key={doTrasy}
              to={doTrasy}
              className={`nav-item${aktywna ? " is-active" : ""}`}
              // To samo, co robil NavLink, ale z naszym kryterium aktywnosci (A-7: stan nie tylko kolorem).
              aria-current={aktywna ? "page" : undefined}
              onClick={onWybor}
            >
              <Ikona className="nav-ico" size={20} />
              <span className="nav-label">{etykieta}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
